/* eslint-disable @typescript-eslint/member-ordering */
import {Injectable, inject} from '@angular/core';
import {AppConfig} from '../_data/config/app-config';

@Injectable({
  providedIn: 'root'
})
export class ApiEndpoints {
  private appConfig = inject(AppConfig);


  private readonly mfaBase = `${this.appConfig.adminServer}/tuc-tudirect-services/mfa`;

  readonly securityLogin = `${this.appConfig.adminServer}/tuc-tudirect-services/security/login`;
  readonly securityAuthenticate = `${this.appConfig.adminServer}/tuc-tudirect-services/security/authenticate`;
  readonly securityRefreshToken = `${this.appConfig.adminServer}/tuc-tudirect-services/security/refresh`;
  readonly securityLogout = `${this.appConfig.adminServer}/tuc-tudirect-services/security/logout`;
  readonly securityUserMigration = `${this.appConfig.adminServer}/tuc-tudirect-services/security/userMigration`;
  readonly companiesAdd = `${this.appConfig.adminServer}/tuc-tudirect-services/company/addCompany`;
  readonly companiesUpdate = `${this.appConfig.adminServer}/tuc-tudirect-services/company/updateCompany`;
  readonly companiesSearch = `${this.appConfig.adminServer}/tuc-tudirect-services/company/searchCompanies`;
  readonly companiesDelete = `${this.appConfig.adminServer}/tuc-tudirect-services/company/deleteCompany`;
  readonly getCompany = `${this.appConfig.adminServer}/tuc-tudirect-services/company/getCompany`;
  readonly companiesGetUsers = `${this.appConfig.adminServer}/tuc-tudirect-services/company/getAllCompanyUsers`;
  readonly memberCodeInfo = `${this.appConfig.adminServer}/tuc-tudirect-services/member/getMemberInfo`;
  readonly branchesForCompany = `${this.appConfig.adminServer}/tuc-tudirect-services/branch/getBranchesByCompany`;
  readonly branchesAdd = `${this.appConfig.adminServer}/tuc-tudirect-services/branch/addBranch`;
  readonly branchesEdit = `${this.appConfig.adminServer}/tuc-tudirect-services/branch/updateBranch`;
  readonly branchesDelete = `${this.appConfig.adminServer}/tuc-tudirect-services/branch/deleteBranch`;
  readonly adminsAdd = `${this.appConfig.adminServer}/tuc-tudirect-services/admin/addNewAdminUser`;
  readonly usersAdd = `${this.appConfig.adminServer}/tuc-tudirect-services/user/addNewUser`;
  readonly usersUpdate = `${this.appConfig.adminServer}/tuc-tudirect-services/user/updateUser`;
  readonly usersUpdateIp = `${this.appConfig.adminServer}/tuc-tudirect-services/user/updateIPRestrictions`;
  readonly usersUpdateAccessTimes = `${this.appConfig.adminServer}/tuc-tudirect-services/user/updateTimeRestrictions`;
  readonly usersUpdateBranches = `${this.appConfig.adminServer}/tuc-tudirect-services/user/addBranchesToUser`;
  readonly usersSearch = `${this.appConfig.adminServer}/tuc-tudirect-services/user/searchByUserName`;
  readonly usersGet = `${this.appConfig.adminServer}/tuc-tudirect-services/user/getUser`;
  readonly userGetCompanyAdmins = `${this.appConfig.adminServer}/tuc-tudirect-services/user/getCompanyAdmins`;
  readonly userGetDetails = `${this.appConfig.adminServer}/tuc-tudirect-services/user/getUserDetails`;
  readonly userNameExists = `${this.appConfig.adminServer}/tuc-tudirect-services/user/getUserNameExists`;
  readonly userEnable = `${this.appConfig.adminServer}/tuc-tudirect-services/user/enableUser`;
  readonly userDisable = `${this.appConfig.adminServer}/tuc-tudirect-services/user/disableUser`;
  readonly userDelete = `${this.appConfig.adminServer}/tuc-tudirect-services/user/deleteUser`;
  readonly userResetPassword = `${this.appConfig.adminServer}/tuc-tudirect-services/user/resetPassword`;
  readonly userChangePassword = `${this.appConfig.adminServer}/tuc-tudirect-services/user/changePassword`;
  readonly userAddBranches = `${this.appConfig.adminServer}/tuc-tudirect-services/user/addBranchesToUser`;
  readonly userSendToken = `${this.appConfig.adminServer}/tuc-tudirect-services/user/sendResetToken`;
  readonly userResetPasswordByToken = `${this.appConfig.adminServer}/tuc-tudirect-services/user/resetPasswordToken`;
  readonly guides = `${this.appConfig.adminServer}/tuc-tudirect-services/home/userGuide`;
  readonly servicesActuatorInfo = `${this.appConfig.adminServer}/tuc-tudirect-services/info`;

  readonly mfaAddUser = `${this.mfaBase}/addNewUser`;
  readonly mfaUserDetails = `${this.mfaBase}/getUserDetails`;
  readonly mfaStartOfflineAuth = `${this.mfaBase}/startOfflineAuth`;
  readonly mfaFinishOfflineAuth = `${this.mfaBase}/finishOfflineAuth`;
  readonly mfaAuthOnline = `${this.mfaBase}/authOnline`;
  readonly mfaCheckAuthStatus = `${this.mfaBase}/checkAuthStatus`;
  readonly mfaStartOfflinePairing = `${this.mfaBase}/startOfflinePairing`;
  readonly mfaFinishOfflinePairing = `${this.mfaBase}/finishOfflinePairing`;
  readonly mfaUnpairDevice = `${this.mfaBase}/unpairDevice`;
  readonly mfaUpdatePrimaryDevice = `${this.mfaBase}/updatePrimaryMFADevice`;
  readonly mfaRequestActivationCode = `${this.mfaBase}/requestActivationCode`;
  readonly mfaAppPairingStatus = `${this.mfaBase}/getAppPairingStatus`;

  readonly reportsActuatorInfo = `${this.appConfig.reportsServer}/tuc-tudirect-reports/info`;
  readonly businessSearchPickList = `${this.appConfig.reportsServer}/tuc-tudirect-reports/nsbe/getPickList`;
  readonly businessGetBusinessFromPickList = `${this.appConfig.reportsServer}/tuc-tudirect-reports/nsbe/getBusinessFromPicklist`;
  readonly businessBestMatch = `${this.appConfig.reportsServer}/tuc-tudirect-reports/nsbe/getBusinessFromBestMatch`;
  readonly ifsPullIfs = `${this.appConfig.reportsServer}/tuc-tudirect-reports/ifs/pullIFS`;
  readonly ifsPullEaml = `${this.appConfig.reportsServer}/tuc-tudirect-reports/ifs/pullIFSEnhancedReport`;
  readonly utilitiesProductDescriptions = `${this.appConfig.reportsServer}/tuc-tudirect-reports/utilities/getProductDescriptions`;
  readonly consumerReport = `${this.appConfig.reportsServer}/tuc-tudirect-reports/consumer/pullConsumerFile`;

}
